// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Usuarios_PegausuariosResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for pegaUsuarios() /usuarios/pegaUsuarios
 * Returns an array of users with enriched franchise data from permissions-service.
 * Proxy to auth-service /admin/usuarios.
 */
import type { Usuarios_PegausuariosRow } from './Usuarios_PegausuariosRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Usuarios_PegausuariosResponseDados = Usuarios_PegausuariosRow[];

export type Usuarios_PegausuariosResponse = ApiResponse<Usuarios_PegausuariosResponseDados>;

registerResponseContract('Usuarios_PegausuariosResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      sub:               { type: 'string',  required: true },
      username:          { type: 'string',  required: true },
      name:              { type: 'string',  required: false },
      email:             { type: 'string',  required: false },
      enabled:           { type: 'boolean', required: false },
      status:            { type: 'string',  required: false },
      phone_number:      { type: 'string',  required: false },
      bgcolor:           { type: 'string',  required: false },
      picture:           { type: 'string',  required: false },
      address:           { type: 'string',  required: false },
      documento:         { type: 'string',  required: false },
      origem:            { type: 'string',  required: false },
      created_at:        { type: 'string',  required: false },
      updated_at:        { type: 'string',  required: false },
      versaoSistema:     { type: 'string',  required: false },
      language:          { type: 'string',  required: false },
      mcp_scopes:        { type: 'string',  required: false },
      dw_scopes:         { type: 'string',  required: false },
      franquias_cognito: { type: 'string',  required: false },
      groups:            { type: 'array',   required: false },
      franquias:         { type: 'array',   required: false },
    },
  },
})
